import script from "./SenderEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./SenderEmail.vue?vue&type=script&setup=true&lang=js"

import "./SenderEmail.vue?vue&type=style&index=0&id=3f57eb44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f57eb44"]])

export default __exports__